import BpkSmallAircraftIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/aircraft';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useTranslation } from '../../helpers/hooks/useTranslation';

import ProductLink from './ProductLink';

import type { FlightInfo, FlightLegInfo } from './types';

const FlightLeg = ({ leg }: { leg: FlightLegInfo }) => {
  const translate = useTranslation();

  const stopsLabel = leg.isDirect
    ? translate('ktxt_Direct')
    : translate('ktxt_combo_rec_indirect');

  return (
    <div className="recommendation-card__flight-leg">
      <div className="recommendation-card__airline-logo-container">
        {leg.airlineLogoUrl ? (
          <img
            className="recommendation-card__airline-logo"
            src={leg.airlineLogoUrl}
            alt={leg.airlineName ?? ''}
            title={leg.airlineName || undefined}
          />
        ) : (
          <span className="recommendation-card__airline-logo-fallback">
            <BpkSmallAircraftIcon aria-hidden="true" />
          </span>
        )}
      </div>
      <div className="recommendation-card__route-info">
        <span>
          <BpkText textStyle={TEXT_STYLES.label2} tagName="span">
            {leg.route}
          </BpkText>
          {' • '}
          <BpkText
            textStyle={TEXT_STYLES.caption}
            tagName="span"
            className={`recommendation-card__stops-text ${
              leg.isDirect
                ? 'recommendation-card__stops-text--direct'
                : 'recommendation-card__stops-text--stops'
            }`}
          >
            {stopsLabel}
          </BpkText>
        </span>
        <span className="recommendation-card__time">
          <BpkText textStyle={TEXT_STYLES.caption}>
            {leg.direction === 'departure'
              ? translate('ktxt_month_view_departing_label')
              : translate('ktxt_month_view_retuning_label')}
          </BpkText>
        </span>
      </div>
    </div>
  );
};

type FlightSectionProps = {
  flight: FlightInfo;
  onLinkClick?: () => void;
};

const FlightSection = ({ flight, onLinkClick }: FlightSectionProps) => {
  const translate = useTranslation();

  return (
    <div className="recommendation-card__product">
      <span className="recommendation-card__product-label">
        <BpkText textStyle={TEXT_STYLES.footnote}>
          {translate('ktxt_combo_rec_your_flight')}
        </BpkText>
      </span>
      <div className="recommendation-card__flights">
        <FlightLeg leg={flight.outbound} />
        {flight.inbound && <FlightLeg leg={flight.inbound} />}
      </div>
      <ProductLink
        label={translate('ktxt_combo_rec_flights_from_price', {
          price: flight.priceFormatted,
        })}
        href={flight.onClickUrl}
        onClick={onLinkClick}
      />
    </div>
  );
};

export default FlightSection;
